import {APPEND_TO_CHECKOUT, SET_CHECKOUT} from "./CheckoutTypes";
import TransformShop from "../../transforms/TransformShop";
import StorageController from "../../controllers/StorageController";


export function checkoutReducer(state = StorageController.restoreCheckout(), action) {
    switch (action.type) {
        case SET_CHECKOUT:
            let newState = TransformShop.checkout(action.data);
            StorageController.storeCheckout(newState)
            return newState;
        case APPEND_TO_CHECKOUT:
            let newState2 = TransformShop.checkout({...state, ...action.data});
            StorageController.storeCheckout(newState2)
            return newState2;
        default:
            return state;
    }
}
